import { render, staticRenderFns } from "./AssessmentTools.vue?vue&type=template&id=1ed26a0e"
import script from "./AssessmentTools.vue?vue&type=script&lang=js"
export * from "./AssessmentTools.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports